import {
  DetailHeader,
  DetailHeaderRow,
  DetailHeaderSection,
} from 'components/DetailHeader/DetailHeader';
import React, { type FC } from 'react';
import { formatDateTime } from 'utils/date';

import { LinkIcon } from '@fragment/ui/src/components/Icon/LinkIcon/LinkIcon';

import { type LinkNode } from './types';

type LinkSummaryProps = {
  link: LinkNode;
};

export const LinkSummary: FC<LinkSummaryProps> = ({ link }) => {
  let env: string | undefined;
  if (link.__typename === 'IncreaseLink') {
    env = link.increaseEnv;
  } else if (link.__typename === 'UnitLink') {
    env = link.unitEnv;
  } else if (link.__typename === 'StripeLink') {
    env = link.stripeEnv;
  }

  return (
    <DetailHeader>
      <DetailHeaderSection>
        <DetailHeaderRow
          label="Link"
          value={
            <div className="flex items-center">
              <LinkIcon type={link.__typename} />
              {link.name}
            </div>
          }
          textToCopy={link.name}
        />
        <DetailHeaderRow label="ID" value={link.id} textToCopy={link.id} />
      </DetailHeaderSection>

      <DetailHeaderSection>
        {env ? (
          <DetailHeaderRow label="Environment" value={<span>{env}</span>} />
        ) : null}

        <DetailHeaderRow
          label="Created"
          value={link.created ? formatDateTime(link.created) : 'N/A'}
          textToCopy={link.created}
        />
      </DetailHeaderSection>
    </DetailHeader>
  );
};
